export default __webpack_public_path__ + "static/media/ja2_thumb.ce642b68.jpg";